export default function (): any {
  return Promise.resolve().then((): any => {
    const localData = localStorage.getItem("groupIndex");
    if (!localData) return 0;
    return +localData;
  });
}
